export enum JobStatus {
	Failed = 'Failed',
	Finished = 'Finished',
	PartiallyFinished = 'PartiallyFinished',
	Postponed = 'Postponed',
	Running = 'Running'
}

export interface IAutoIngestJobInfo {
	failedRecordings: number;
	jobDetails: string;
	processedRecordings: number;
	remainingRecordings: number;
	status: JobStatus;
	totalRecordings: number;
	whenRequested: Date;
}
